import { render, staticRenderFns } from "./user-modal-add.vue?vue&type=template&id=742625b6&scoped=true"
import script from "./user-modal-add.vue?vue&type=script&lang=js"
export * from "./user-modal-add.vue?vue&type=script&lang=js"
import style0 from "./user-modal-add.vue?vue&type=style&index=0&id=742625b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742625b6",
  null
  
)

export default component.exports